import { Box, CircularProgress, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { ReactNode } from "react";
import { Cartao, Rotulo } from "../../../../core/styles/superficies";

interface CartaoIndicadorProps {
    rotulo: string;
    valor: ReactNode;
    icone: ReactNode;
    /** Cor de realce do ícone. Padrão: primary. */
    cor?: string;
    carregando?: boolean;
}

/** Indicador numérico da tela de caixa — mesmo formato para todos os números exibidos. */
export const CartaoIndicador = ({ rotulo, valor, icone, cor, carregando }: CartaoIndicadorProps) => (
    <Cartao sx={{ height: "100%" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, padding: 2.5 }}>
            <Box
                sx={{
                    width: 44,
                    height: 44,
                    flexShrink: 0,
                    borderRadius: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: cor ?? (theme => theme.palette.primary.main),
                    backgroundColor: theme => alpha(cor ?? theme.palette.primary.main, 0.12),
                    "& svg": { fontSize: 22 },
                }}
            >
                {icone}
            </Box>
            <Box sx={{ minWidth: 0 }}>
                <Rotulo>{rotulo}</Rotulo>
                {carregando ? (
                    <Box sx={{ height: 36, display: "flex", alignItems: "center" }}>
                        <CircularProgress size={20} />
                    </Box>
                ) : (
                    <Typography
                        noWrap
                        sx={{ fontSize: "1.375rem", fontWeight: 700, lineHeight: 1.6 }}
                    >
                        {valor}
                    </Typography>
                )}
            </Box>
        </Box>
    </Cartao>
);
